export const GET_CURRENT_WEATHER = 'GET_CURRENT_WEATHER';
export const GET_COMING_WEATHER = 'GET_COMING_WEATHER';
export const GET_USER_POSITION = 'GET_USER_POSITION';

export const SEARCH_ERROR = 'SEARCH_ERROR';
export const API_KEY_ERROR = 'API_KEY_ERROR';
export const NETWORK_ERROR = 'NETWORK_ERROR';
export const SERVER_ERROR = 'SERVER_ERROR';

export const CHANGE_TEMPERATURE_UNIT = 'CHANGE_TEMPERATURE_UNIT';
export const CHANGE_API_KEY = 'CHANGE_API_KEY';
export const GET_WEATHER = '[WEATHER APP] GET WEATHER DATA FROM API';